import API from './API';
import URLSearchParams from 'url-search-params';
import FeatureActions from 'actions/FeatureActions';

const FeatureSource = {
  getRemoteFeatures: {
    remote(state) {
      const fetchUrl = API.getFeatureList;
      const searchParams = new URLSearchParams();
      for(let k in state.params) {
        if(k === 'first' || k === 'maxCount'){
          searchParams.append(k, state.params[k]);
        }
      }
      return fetch(`${fetchUrl}&${searchParams}`).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: FeatureActions.fetchSuccess,
    error: FeatureActions.fetchError
  },
  getRemoteFeature: {
    remote(state) {
      const fetchUrl = API.getFeatureDetail;
      return fetch(fetchUrl.replace(':id', state.featureId)).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: FeatureActions.updateFeature,
    error: FeatureActions.fetchError
  },
  postEditFeature: {
    remote(state) {
      const fetchUrl = API.postUpdateFeature;
      let params = {
        method: 'POST',
        headers: API.jsonHeader,
        body: JSON.stringify({
          name: state.params.name,
          summary: state.params.summary,
          ad_url: state.params.ad_url,
          avatar: state.params.avatar,
          user_id: state.params.user_id,
          business_id: state.params.business_id
        })
      };
      return fetch(fetchUrl.replace(':id',state.params.feature_id), params).then(response => response.json());
    },
    local() {
      return null;
    },
    shouldFetch() {
      return true;
    },
    success: FeatureActions.refreshFeature,
    error: FeatureActions.fetchError
  },
  deleteRemoteFeature: {
    remote(state){
      let param = {
        method: 'POST',
        body: `business_id=${state.featureId}`,
        headers: API.urlHeader
      };
      return fetch(API.postFeatureDelete.replace(':id',state.featureId), param).then(res=>res.json()).then(json=>{
        return json;
      });
    },
    shouldFetch() {
      return true;
    },
    success: FeatureActions.deleteFeatureSuccess,
    error: FeatureActions.fetchError
  }
};

export default FeatureSource;



// WEBPACK FOOTER //
// ./src/sources/FeatureSource.js